import { z } from 'zod';

export const ClickedProfilingEventSchema = z
	.object({
		event: z.literal('click'),
	})
	.strip();

export const NavigationTimingProfilingEventSchema = z
	.object({
		event: z.literal('navigation-timing'),
		transferSize: z.number().nonnegative().finite(),
		duration: z.number().nonnegative().finite(),
	})
	.strict();

const initiatorTypeValues = z.enum([
	'script',
	'fetch',
	'css',
	'link',
	'iframe',
	'img',
	'image',
	'xmlhttprequest',
	'other',
]);
export const ResourceTimingProfilingEventSchema = z
	.object({
		event: z.literal('resource-timing'),
		start: z.number().nonnegative().finite(),
		duration: z.number().nonnegative().finite(),
		transferSize: z.number().nonnegative().finite(),
		initiatorType: z
			.string()
			.pipe(initiatorTypeValues.catch(initiatorTypeValues.Values.other))
			.pipe(z.string()),
	})
	.strict();

export const LayoutShiftProfilingEventSchema = z
	.object({
		event: z.literal('dcls-score'),
		score: z.number().nonnegative().finite(),
		timestamp: z.number().nonnegative().finite(),
		inputFlag: z.boolean(),
	})
	.strict();

export const FCPProfilingEventSchema = z
	.object({
		event: z.literal('fcp-snapshot'),
		start: z.number().nonnegative().finite(),
	})
	.strict();

export const LCPProfilingEventSchema = z
	.object({
		event: z.literal('lcp-snapshot'),
		size: z.number().nonnegative().finite(),
		start: z.number().nonnegative().finite(),
	})
	.strict();

export const AppFrameProfilingEventSchema = z.discriminatedUnion('event', [
	ClickedProfilingEventSchema,
	NavigationTimingProfilingEventSchema,
	ResourceTimingProfilingEventSchema,
	LayoutShiftProfilingEventSchema,
	FCPProfilingEventSchema,
	LCPProfilingEventSchema,
]);

export type FrameProfilingEventType = z.infer<typeof AppFrameProfilingEventSchema>;
